import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
function ComparisonTools() {
  const { isTheme } = useSelector((state) => state.currentStage)
  const handleLayerChange = () => {
    console.log("")
  }
  return (
    <div>
      <h6 className='tools-title mb-0'>Compare Tool</h6>
      <CustomSelectMain
        options={["Bhopal"]}
        optionPlaceholder="Select District name hare"
        handleFieldValueChange={handleLayerChange}
      />
       <CustomSelectMain
        options={["Bhopal"]}
        optionPlaceholder="Select Urban local body"
        handleFieldValueChange={handleLayerChange}
      />
       {isTheme === 'light' ?
        <button className='btn-theme'>Run Tax Analysis</button>
        :
        <button className='btn-comman btn-runtax comman-text mt-3'>Run Tax Analysis</button>
      }

      <div className='comparenotediv'>
        <h5>Note*</h5>
        <h6>
          To facilitate comparison, users must select a layer for both the left and right sides. Upon clicking the "Compare" button, the map displays a partitioned view, with the selected layers on the left and right sides.
        </h6>
        <div className='comparemapdiv'>
          <img src="img/Comparisson.png" alt='map' width="90%" height="90%"/>
        </div>
      </div>
    </div>
  )
}

const CustomSelectMain = ({ options = [], optionPlaceholder, handleFieldValueChange, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef(null);
  const containerRef = useRef(null);
  const { isTheme } = useSelector((state) => state.currentStage)


  const selectStyles = {
    container: {
      position: 'relative',
      marginTop: '10px',
    },
    selectButton: {
      width: '100%',
      padding: '8px 12px',
      border: 'none',
      borderRadius: isOpen ? '4px 4px 0 0' : '4px',
      backgroundColor: isTheme === 'light' ? '#F5F5F5' : '#002864',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: '500',
      color: isTheme === 'light' ? '#000000' : 'white'
    },
    dropdownContainer: {
      width: '100%',
      backgroundColor: '#002864',
      border: 'none',
      borderRadius: '0 0 4px 4px',
      color: 'white',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    },
    option: {
      padding: '6px 12px',
      cursor: 'pointer',
      backgroundColor: '#002864',
      color: 'white',
      transition: 'background-color 0.2s ease',
      fontSize: '14px',
      fontWeight: "400",
      borderTop: "0.5px solid #0e0e0e",
      borderBottom: "0.5px solid #0e0e0e"
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    if (disabled) return;
    setSelectedOption(option);
    setIsOpen(false);
    handleFieldValueChange(option);
  };



  console.log("optionsoptions", options)



  return (
    <div style={selectStyles.container} ref={containerRef}>
      <div
        style={selectStyles.selectButton}
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <span
          style={{
            color: disabled ? isTheme === 'light' ? '#7E7E7E' : "rgba(255, 255, 255, 0.75)" : isTheme === 'light' ? '#000000' : "white",
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >{selectedOption ? selectedOption.lable || selectedOption.name : optionPlaceholder}</span>
        <span style={{
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.2s ease'
        }}>▼</span>
      </div>

      {isOpen && !disabled && (
        <div style={selectStyles.dropdownContainer} ref={dropdownRef}>
          {options.map((option) => (
            <div
              key={option.id}
              style={{
                ...selectStyles.option,
                backgroundColor: selectedOption?.id === option.id ? '#2465c6' : 'black'
              }}
              onClick={() => handleSelect(option)}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#2465c6';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor =
                  selectedOption?.id === option.id ? '#2465c6' : 'black';
              }}
            >
              {option?.lable || option?.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ComparisonTools